import { translate } from 'App/Internationalization';
import images from 'config/local/images';
import LinkButton from 'shared/LinkButton';
import paths from 'config/local/paths';
import React from 'react';

export default class GenericValuationOverlay extends React.Component {
	// eslint-disable-next-line class-methods-use-this
	render() {
		return (
			<section className="w-3/4 mx-auto my-5 message message-themed-light">
				<header className="header">
					<h2 className="title large">
						{translate(
							'agent.pages.widgets.lead_generation.gated.cta'
						)}
					</h2>
				</header>
				<main className="container-sm">
					<ul className="list-group">
						<li
							// eslint-disable-next-line react/no-danger -- Markdown
							dangerouslySetInnerHTML={{
								__html: translate(
									'agent.pages.widgets.lead_generation.gated.increase'
								),
							}}
						/>
						<li
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: translate(
									'agent.pages.widgets.lead_generation.gated.personalized'
								),
							}}
						/>
						<li
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: translate(
									'agent.pages.widgets.lead_generation.gated.build_trust'
								),
							}}
						/>
					</ul>
				</main>
				<footer className="footer">
					<LinkButton
						className="button button-icon"
						icon={images.icons.subscription}
						iconClass="icon"
						to={paths.app.agent.subscription.root}
					>
						{translate(
							'agent.pages.contacts.view.upgrade_table.upgrade'
						)}
					</LinkButton>
				</footer>
			</section>
		);
	}
}
